import { format } from "date-fns";
import { isEqual } from "lodash";
var formatTagValue = function formatTagValue(field, value) {
  if (value == null || value === "") return "";
  switch (field.tag_type) {
    case "boolean":
      return value ? "Yes" : "No";
    case "date":
      try {
        return format(new Date(String(value)), "d MMM yyyy");
      } catch (_unused) {
        return String(value);
      }
    case "datetime":
      try {
        return format(new Date(String(value)), "d MMM yyyy, h:mm a");
      } catch (_unused2) {
        return String(value);
      }
    case "multi_dropdown":
    default:
      return Array.isArray(value) ? value.join(", ") : String(value);
  }
};

/** Maps raw API custom tags to display-ready AITag objects, resolving labels via customFields and applied state via patientTags. */
export function mapCustomTagsToAITags(customTags, customFields, patientTags) {
  return (customTags !== null && customTags !== void 0 ? customTags : []).map(function (tag) {
    var field = customFields.find(function (f) {
      return (f === null || f === void 0 ? void 0 : f.id) != null && String(f.id) === String(tag.tag_id);
    });
    if (!field) return null;
    var formatted = formatTagValue(field, tag.response);
    var applied = patientTags.some(function (pt) {
      return String(pt.tag_id) === String(tag.tag_id) && isEqual(pt.response, tag.response);
    });
    return {
      id: String(tag.tag_id),
      type: "indication",
      label: formatted ? "".concat(field.tag, ": ").concat(formatted) : field.tag,
      tagId: Number(tag.tag_id),
      response: tag.response,
      applied: applied
    };
  }).filter(function (t) {
    return t !== null;
  });
}